<template>
  <text-box :label="`Media ${customKpiName} by Segment (${unit})`" icon="segment">
    <template v-slot:info v-if="precision">
      <percent-chip :value="precision" :best="100" icon="mdi-bullseye-arrow"/>
    </template>
    <template v-slot:info-dialog>
      Projected sales contribution by demographic segment
    </template>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <sales-by-segment :data="totalSalesBySegment" :colors="colors" :precision="precision" :hide-title="true" :custom-kpi-name="customKpiName"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="colsPerRow" v-for="channel in marketing" :key="channel[0]">
          <marketing-sales-detail-channel :data="channel[1]" :total ="totalSales" :code="channel[0]" :colors="colors" :custom-kpi-name="customKpiName"/>
        </v-col>
      </v-row>
    </v-container>
  </text-box>
</template>

<script>
import _ from 'lodash'

import TextBox from '@/components/TextBox.vue'
import MarketingSalesDetailChannel from '@/components/simulationDetails/MarketingSalesDetailChannel.vue'
import PercentChip from '@/components/PercentChip.vue'
import SalesBySegment from '@/components/simulationDetails/SalesBySegment.vue'

export default {
  data () {
    return {}
  },
  computed: {
    marketing: function () {
      var sortable = []
      for (var key in this.data.marketing) {
        sortable.push([key, this.data.marketing[key]])
      }
      if (this.sort) {
        sortable.sort(function (a, b) {
          return b[1].adstock - a[1].adstock
        })
      }
      return sortable
    },
    totalSalesBySegment: function () {
      var result = {}
      var keys = Object.keys(this.data.marketing)
      for (var index in keys) {
        result = _.mergeWith({}, result, JSON.parse(JSON.stringify(this.data.marketing[keys[index]].segments)), (a, b) => _.defaultTo(_.add(a, b), undefined))
      }
      return {
        'segments': result
      }
    },
    totalSales: function () {
      if (this.data.components.marketing) {
        return this.data.components.marketing
      } else {
        let total = 0
        this.marketing.forEach(element => {
          if (element && element[1] && element[1].adstock) {
            total += element[1].adstock
          }
        })
        return total
      }
    }
  },
  methods: {},
  props: {
    data: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      required: false
    },
    precision: {
      type: Number,
      required: false
    },
    colsPerRow: {
      type: Number,
      required: false,
      default: function () {
        return 4
      }
    },
    sort: {
      type: Boolean,
      required: false,
      default: function () {
        return true
      }
    },
    unit: {
      type: String,
      required: false,
      default: function () {
        return 'USD'
      }
    },
    customKpiName: {
      type: String,
      required: true
    }
  },
  components: {
    TextBox,
    MarketingSalesDetailChannel,
    PercentChip,
    SalesBySegment
  }
}
</script>
